<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :title="meunTitle"></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainbody">
            <div class="agreement-section" v-for="item in agreementList" :key="item.flag">
              <div class="section-header">
                <span class="title">{{ item.label }}</span>
                <div class="section-actions">
                  <el-button size="small" @click="reset(item.flag)">重置</el-button>
                  <el-button size="small" type="primary" v-preventReClick @click="saveEdit(item.flag)">提交</el-button>
                </div>
              </div>
              <VueUeditorWrap class="section-editor" :destroy="true" v-model="item.value" :config="editorConfig" />
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as Utils from '@/utils/utils.js'
import * as StrUtils from '@/utils/strUtils.js'
import * as Constant from '@/utils/constant.js'
import * as CApi from '@/api/constant_api.js'
import * as Api from '@/api/api.js'
import { isEmpty } from '@/utils/strUtils'
import { URL_PATH, Editor_Config } from '@/config/config'
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import headerLayout from '@/components/layout/headerLayoutWxapp'
import VueUeditorWrap from 'vue-ueditor-wrap'

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    VueUeditorWrap
  },
  activated() {
    this.getInfo()

  },
  deactivated() {},
  data() {
    return {
      meunItem: null,
      meunTitle: '',
      welfareDisclaimers: '',
      welfareDisclaimersServer: '',
      welfareRSMG: '',
      welfareRSMGServer: '',
      welfareRSMSP: '',
      welfareRSMSPServer: '',
      appletPrivacyAgreement: '',
      appletPrivacyAgreementServer: '',
      welfareCampusVisitPrivacy: '',
      welfareCampusVisitPrivacyServer: '',
      editorConfig: Editor_Config,
      agreementList: [
        { flag: 1, label: '免责声明', field: 'welfareDisclaimers', value: '' },
        { flag: 2, label: '体育馆专项管理条例', field: 'welfareRSMG', value: '' },
        { flag: 3, label: '游泳馆专项管理条例', field: 'welfareRSMSP', value: '' },
        { flag: 4, label: '小程序隐私协议', field: 'appletPrivacyAgreement', value: '' },
        { flag: 5, label: '预约入校隐私协议', field: 'welfareCampusVisitPrivacy', value: '' }
      ]
    }
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem
      this.meunTitle = this.meunItem.name
      this.getInfo()
    },
    // 获取
    getInfo() {
      this.$api
        .agreementManagement({
          token: localStorage.getItem('token')
        })
        .then(({ data }) => {
          this.welfareDisclaimers = data.Data.welfareDisclaimers
          this.welfareDisclaimersServer = data.Data.welfareDisclaimers
          this.welfareRSMG = data.Data.welfareRSMG
          this.welfareRSMGServer = data.Data.welfareRSMG
          this.welfareRSMSP = data.Data.welfareRSMSP
          this.welfareRSMSPServer = data.Data.welfareRSMSP
          this.appletPrivacyAgreement = data.Data.appletPrivacyAgreement
          this.appletPrivacyAgreementServer = data.Data.appletPrivacyAgreement
          this.welfareCampusVisitPrivacy = data.Data.welfareCampusVisitPrivacy
          this.welfareCampusVisitPrivacyServer = data.Data.welfareCampusVisitPrivacy
          // 同步到 agreementList
          this.agreementList.forEach(item => {
            item.value = this[item.field]
          })
        })
        .catch(({ error }) => {})
    },
    saveEdit(flag) {
      const item = this.agreementList.find(a => a.flag === flag)
      if (!item) return
      const field = item.field
      const value = item.value
      this.$api
        .updateAgreementManagement({
          token: localStorage.getItem('token'),
          field: field,
          value: value
        })
        .then(({ data }) => {
          this.getInfo()
          this.$message({
            message: '编辑成功',
            type: 'success'
          })
        })
        .catch(({ error }) => {})
    },
    reset(flag) {
      const item = this.agreementList.find(a => a.flag === flag)
      if (!item) return
      const serverValue = this[item.field + 'Server']
      item.value = isEmpty(serverValue) ? '' : serverValue
    }
  }
}
</script>

<style lang="less" scoped>
.mainbody {
  background-color: #ffffff;
  border-radius: 5px;
  padding: 24px 32px 40px;
}
.agreement-section {
  padding: 20px 0;
  border-bottom: 1px solid #ebeef5;
  &:last-child {
    border-bottom: none;
  }
}
.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
}
.section-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.section-editor {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wxapp/agreemenManager.vue